import { Avatar, styled } from '@mui/material';

const StatusAvatar = styled(Avatar)`
  margin: 4px;
  background-color: ${({ color }) => color};
`;

export default StatusAvatar;
